import './Header.scss';

const Header = () =>{
    return(
        <div className="header">
            <h1>Popular Tour Places</h1>
        </div>
    )
}

export default Header;